module.exports = __webpack_public_path__ + "media/images/ride_requests/map_circle-9fe02f7fe9a7b20c871798cef191c048.svg";